<div class="error-container">
  <h1>401 - Unauthorized</h1>
  <p>You are not authenticated to access this resource.</p>
  <button>Login</button> <!-- 可选：触发MSAL登录 -->
</div>